export const queryKeys = {
  dashboard: 'dashboard',
  patients: 'patients',
  patientDetails: 'patientDetails',
  practitioners: 'practitioners',
  getItemInsuranceEligibility: 'getItemInsuranceEligibility',
  countries: 'countries',
  getSearchBankAccount: 'getSearchBankAccount',
  getDashboard: 'getDashboard',
  getToDo: 'getToDo',
  getStockAnalytics: 'getStockAnalytics',
  getPurchaseAnalytics: 'getPurchaseAnalytics',
  getSearchBranch: 'getSearchBranch',
  getZatcaDetailsReport: 'getZatcaDetailsReport',
  getItemGroup: 'getItemGroup',
  getItemPriceReport: 'getItemPriceReport',
  getZatcaSummaryReport: 'getZatcaSummaryReport',
  getSalesOrderDetails: 'getSalesOrderDetails',
  getWarehouseSearch: 'getWarehouseSearch',
  getSearchAddress: 'getSearchAddress',
  getMopAccountMode: 'getMopAccountMode',
  getBalanceSheet: 'getBalanceSheet',
  getAddress: 'getAddress',
  getPrintFormat: 'getPrintFormat',
  getProfitAndLoss: 'getProfitAndLoss',
  getAccountsPayableSummary: 'getAccountsPayableSummary',
  getNotifications: 'getNotifications',
  getStatementOfAccount: 'getStatementOfAccount',
  getCashFlow: 'getCashFlow',
  getEmployeeDetails: 'getEmployeeDetails',
  getAccountsReceivableSummary: 'getAccountsReceivableSummary',
  getCustomerData: 'getCustomerData',
  getAccountingPeriodById: 'getAccountingPeriodById',
  getFiscalYearById: 'getFiscalYearById',
  getSearchIncomeAccount: 'getSearchIncomeAccount',
  getAccountingPeriod: 'getAccountingPeriod',
  getSearchWarehouse: 'getSearchWarehouse',
  getSearchPatientsLeavePolicy: 'getSearchPatientsLeavePolicy',
  getPayrollEntryDetails: 'getPayrollEntryDetails',
  createPartialSalesInvoice: 'createPartialSalesInvoice',
  createFullInvoice: 'createFullInvoice',
  getSearchApiDuningTerms: 'getSearchApiDuningTerms',
  getSearchPatientsEmployee: 'getSearchPatientsEmployee',
  getAttandenceDetails: 'getAttandenceDetails',
  getSearchAccountManager: 'getSearchAccountManager',
  getEmployeesPayroll: 'getEmployeesPayroll',
  getCompanyDetailsPayroll: 'getCompanyDetailsPayroll',
  getSearchApiJournalEntry: 'getSearchApiJournalEntry',
  payrollEntryHasBank: 'payrollEntryHasBank',
  getAttandence: 'getAttandence',
  getSearchApiSalesOrder: 'getSearchApiSalesOrder',
  getPaymentEntryDetailsEmployee: 'getPaymentEntryDetailsEmployee',
  getSearchApiSalesInvoice: 'getSearchApiSalesInvoice',
  getSalaryDeduction: 'getSalaryDeduction',
  getPaymentVoucher: 'getPaymentVoucher',
  getSearchApiSales: 'getSearchApiSales',
  getEmployeeSearch: 'getEmployeeSearch',
  getSalesOrder: 'getSalesOrder',
  getPayrollEntry: 'getPayrollEntry',
  getCompanyInfoClaim: 'getCompanyInfoClaim',
  getSalarySlip: 'getSalarySlip',
  getSearcApiItemCode: 'getSearcApiItemCode',
  getSearchApiIsStock: 'getSearchApiIsStock',
  getTrialBalance: 'getTrialBalance',
  getPaymentReceiptVoucher: 'getPaymentReceiptVoucher',
  getAppointmentsDetails: 'getAppointmentsDetails',
  getSearchCostCenter: 'getSearchCostCenter',
  getSearchUser: 'getSearchUser',
  getSearchPricelist: 'getSearchPricelist',
  getJournalEntryDetailsName: 'getJournalEntryDetailsName',
  getSearchApiExpenseClaim: 'getSearchApiExpenseClaim',
  getSalaryStructureHr: 'getSalaryStructureHr',
  getSearchPractitioners: 'getSearchPractitioners',
  getItemsSearch: 'getItemsSearch',
  getExpenseClaimSubmit: 'getExpenseClaimSubmit',
  getSearchApiWarehouse: 'getSearchApiWarehouse',
  getStockEntryName: 'getStockEntryName',
  getSearchApiHolidayList: 'getSearchApiHolidayList',
  getSearchApiCostCenter: 'getSearchApiCostCenter',
  getSearchApiAccountList: 'getSearchApiAccountList',
  getSearchPatients: 'getSearchPatients',
  getPaymentEntryDetailsName: 'getPaymentEntryDetailsName',
  getGeneraledgerReport: 'getGeneraledgerReport',
  getSearchSalaryStructure: 'getSearchSalaryStructure',
  getSearchApPurchaseInvoice: 'getSearchApPurchaseInvoice',
  getAccountDetails: 'getAccountDetails',
  getSearchApiSalaryComponents: 'getSearchApiSalaryComponents',
  getDepartmentHr: 'getDepartmentHr',
  getSalaryStructureAssignment: 'getSalaryStructureAssignment',
  getPurchaseReturn: 'getPurchaseReturn',
  getCompany: 'getCompany',
  getSearchApiCostCenters: 'getSearchApiCostCenters',
  getSalaryComponentHr: 'getSalaryComponentHr',
  getChartAccountParent: 'getChartAccountParent',
  getSearchAccount: 'getSearchAccount',
  getStockLedgerReport: 'getStockLedgerReport',
  getStockBalance: 'getStockBalance',
  getLandedCostVoucherItemsDerails: 'getLandedCostVoucherItemsDerails',
  getSearchApiSalaryComponent: 'getSearchApiSalaryComponent',
  getSymptoms: 'getSymptoms',
  getBranchHr: 'getBranchHr',
  getAccountSearchUser: 'getAccountSearchUser',
  getDesignationHr: 'getDesignationHr',
  getAccountSearchCostCenter: 'getAccountSearchCostCenter',
  getSearchApiAdvanceAccount: 'getSearchApiAdvanceAccount',
  getSearchApiModeOfPayment: 'getSearchApiModeOfPayment',
  getEmployeeAdvance: 'getEmployeeAdvance',
  getAdditionalSalay: 'getAdditionalSalay',
  getAccountSearchDepartment: 'getAccountSearchDepartment',
  getSearchApiCompanyName: 'getSearchApiCompanyName',
  getMapReferencePR: 'getMapReferencePR',
  getExpenseClaim: 'getExpenseClaim',
  getSearchApiChoice: 'getSearchApiChoice',
  getSearchApiAccount: 'getSearchApiAccount',
  getLandedCostVoucher: 'getLandedCostVoucher',
  getPurchaseInvoiceDetails: 'getPurchaseInvoiceDetails',
  getServices: 'getServices',
  getPurchaseRecieptReturn: 'getPurchaseRecieptReturn',
  getMaterialDetailsInStock: 'getMaterialDetailsInStock',
  getEmploymentTypeSearch: 'getEmploymentTypeSearch',
  getItemGroupSearch: 'getItemGroupSearch',
  getDesignationSearch: 'getDesignationSearch',
  getLeaveAllocation: 'getLeaveAllocation',
  getDebitNote: 'getDebitNote',
  getDebitNoteList: 'getDebitNoteList',
  getPurchaseInvoiceView: 'getPurchaseInvoiceView',
  getLeaveApplication: 'getLeaveApplication',
  getMapReferenceMakePI: 'getMapReferenceMakePI',
  getLeavePolicyAssign: 'getLeavePolicyAssign',
  getStockEntry: 'getStockEntry',
  getHolidayList: 'getHolidayList',
  getSearchApiEmployee: 'getSearchApiEmployee',
  getSearchApiLeaveType: 'getSearchApiLeaveType',
  getEmployeeSearch: 'getEmployeeSearch',
  getDataApi: 'getDataApi',
  getCostCenterSearch: 'getCostCenterSearch',
  getLeavePolicy: 'getLeavePolicy',
  getLeaveTypeSearch: 'getLeaveTypeSearch',
  getLeaveType: 'getLeaveType',
  getCurrencsearch: 'getCurrencsearch',
  getBranchSearch: 'getBranchSearch',
  getUserSearch: 'getUserSearch',
  getMapReferenceRecieptAndInvoiceReciept:
    'getMapReferenceRecieptAndInvoiceReciept',
  getSearchApiSupplier: 'getSearchApiSupplier',
  getStockReconcillation: 'getStockReconcillation',
  getDepartmentSearch: 'getDepartmentSearch',
  getEmployee: 'getEmployee',
  getPriceListSearch: 'getPriceListSearch',
  getMapReferenceRecieptAndInvoiceOrderPI:
    'getMapReferenceRecieptAndInvoiceOrderPI',
  getPriceListsSupplier: 'getPriceListsSupplier',
  getMapReferenceMakePR: 'getMapReferenceMakePR',
  getMapReferenceRecieptAndInvoiceOrder:
    'getMapReferenceRecieptAndInvoiceOrder',
  getItemDetails: 'getItemDetails',
  getMapReferenceRecieptAndInvoice: 'getMapReferenceRecieptAndInvoice',
  getPurchaseReciept: 'getPurchaseReciept',
  getAccountSearch: 'getAccountSearch',
  getPurchaseInvoice: 'getPurchaseInvoice',
  getSupplier: 'getSupplier',
  getMakePurchaseOrder: 'getMakePurchaseOrder',
  getPurchaseOrder: 'getPurchaseOrder',
  getSuppliers: 'getSuppliers',
  getPatientInsuranceCoverage: 'getPatientInsuranceCoverage',
  getAllItems: 'getAllItems',
  getItem: 'getItem',
  getItemTaxTemplate: 'getItemTaxTemplate',
  getstockUomsUom: 'getstockUomsUom',
  getItemPrice: 'getItemPrice',
  getCostCentersSearch: 'getCostCentersSearch',
  getSearchApi: 'getSearchApi',
  getComplaint: 'getComplaint',
  getPriceList: 'getPriceList',
  getStockItems: 'getStockItems',
  getUnitMeasure: 'getUnitMeasure',
  getSupplierGroup: 'getSupplierGroup',
  getMaterialRequest: 'getMaterialRequest',
  getBankAccount: 'getBankAccount',
  getWarehouse: 'getWarehouse',
  getBank: 'getBank',
  getReconcillation: 'getReconcillation',
  getInsuranceClaimDetails: 'getInsuranceClaimDetails',
  getInsuranceClaim: 'getInsuranceClaim',
  getLinkedEntries: 'getLinkedEntries',
  getCostCenterAllocation: 'getCostCenterAllocation',
  getCreditNotes: 'getCreditNotes',
  getPractitionerScheduleInfo: 'getPractitionerScheduleInfo',
  getAllServicesAndItem: 'getAllServicesAndItem',
  getInsuranceClaimFilter: 'getInsuranceClaimFilter',
  getPaymentEntries: 'getPaymentEntries',
  getJournalEntries: 'getJournalEntries',
  getModeOfPayments: 'getModeOfPayments',
  getItemInsuranceEligibilityById: 'getItemInsuranceEligibilityById',
  getFiscalYear: 'getFiscalYear',
  getEligibilityPlanById: 'getEligibilityPlanById',
  getJournalEntryDetails: 'getJournalEntryDetails',
  getPayorContractsById: 'getPayorContractsById',
  countriesWithLanguages: 'countriesWithLanguages',
  getEligibilityPlans: 'getEligibilityPlans',
  languages: 'languages',
  getPatientInsurancePoliciesById: 'getPatientInsurancePoliciesById',
  getCostCenterParties: 'getCostCenterParties',
  getPaymentEntryDetails: 'getPaymentEntryDetails',
  getCostCenterDetails: 'getCostCenterDetails',
  getIBnpi: 'getIBnpi',
  getPriceListAndRate: 'getPriceListAndRate',
  getCustomer: 'getCustomer',
  getAccounts: 'getAccounts',
  getLastEncounter: 'getLastEncounter',
  getLastInvoice: 'getLastInvoice',
  getAccountsBalances: 'getAccountsBalances',
  getCustomerSalesInvoices: 'getCustomerSalesInvoices',
  getCostCenters: 'getCostCenters',
  getIllnesses: 'getIllnesses',
  getPayorContracts: 'getPayorContracts',
  getEligibilityPlans: 'getEligibilityPlans',
  getInsurancePayors: 'getInsurancePayors',
  getEncountersDetails: 'getEncountersDetails',
  getSalesInvoices: 'getSalesInvoices',
  getSellingPriceLists: 'getSellingPriceLists',
  getParties: 'getParties',
  getAccountsTree: 'getAccountsTree',
  getPaymentReferences: 'getPaymentReferences',
  getGeneralLedger: 'getGeneralLedger',
  getVatTax: 'getVatTax',
  getDepartments: 'getDepartments',
  getPayorContract: 'getPayorContract',
  getInsurancePayors: 'getInsurancePayors',
  getReceivableAccounts: 'getReceivableAccounts',
  getExpenseAccounts: 'getExpenseAccounts',
  getMedicalCodeStandards: 'getMedicalCodeStandards',
  getAppointments: 'getAppointments',
  getSalesInvoiceDetails: 'getSalesInvoiceDetails',
  getPatients: 'getPatients',
  getAppointmentTypes: 'getAppointmentTypes',
  getDepartmentsList: 'getDepartmentsList',
  getPractitionerschedulesList: 'getPractitionerschedulesList',
  getEncountersList: 'getEncountersList',
  getSymptoms: 'getSymptoms',
  getItemGroups: 'getItemGroups',
  getStockUoms: 'getStockUoms',
  addPatientInsurancePolicy: 'addPatientInsurancePolicy',
  getPractitionersDetails: 'getPractitionersDetails',
  getPriceLists: 'getPriceLists',
  getDiagnosis: 'getDiagnosis',
  getLabTestsDetails: 'getLabTestsDetails',
  getPatientInsurancePolicies: 'getPatientInsurancePolicies',
  getValidPatientInsurancePolicies: 'getValidPatientInsurancePolicies',
  getInsurancePayors: 'getInsurancePayors',
  getPatientCareTypes: 'getPatientCareTypes',
  getMaterials: 'getMaterials',
  getServiceUnits: 'getServiceUnits',
  getMedicalCodes: 'getMedicalCodes',
  get_Specialty: 'get_Specialty',
  getLeavePolicySearch: 'getLeavePolicySearch',
  get_contract_type: 'get_contract_type',
  get_account_details: 'get_account_details',
  getServiceUnitTypes: 'getServiceUnitTypes',
  getWarehouses: 'getWarehouses',
  getItemGroups: 'getItemGroups',
  getLabTestsList: 'getLabTestsList',
  getLabTestTemplates: 'getLabTestTemplates',
  getPractitioners: 'getPractitioners',
  getEmployees: 'getEmployees',
  getItems: 'getItems',
  getMaterialsList: 'getMaterialsList',
  get_practitioner_schedules: 'get_practitioner_schedules',
  getAvailableTimeSlots: 'getAvailableTimeSlots',
  getInsurancePayorsById: 'getInsurancePayorsById',
};
